import { render, staticRenderFns } from "./MemberDiscount.vue?vue&type=template&id=f9f148c8&scoped=true&"
import script from "./MemberDiscount.vue?vue&type=script&lang=js&"
export * from "./MemberDiscount.vue?vue&type=script&lang=js&"
import style0 from "./MemberDiscount.vue?vue&type=style&index=0&id=f9f148c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f148c8",
  null
  
)

export default component.exports